import type { InvoiceDate, InvoiceReviewStatus } from '@weft/types';
import { dayjs } from '@weft/utils';

const month = dayjs().month();
const year = dayjs().year();

export const DEFAULT_INVOICES_TABLE_SELECTED_MONTHS: InvoiceDate[] = [{ month: month.toString(), year }];

export const DEFAULT_INVOICES_TABLE_SELECTED_ROWS = [];

export const DEFAULT_INVOICES_TABLE_SELECTED_BILLING_STATUSES = [];

export const DEFAULT_INVOICES_TABLE_SELECTED_WORKFLOW: InvoiceReviewStatus[] = [];
